import React from 'react';
import {observer} from 'mobx-react-lite';
import intl from 'react-intl-universal';

import {serverAvailabilityStore} from '@stores/serverConnection/serverAvailability';

import './ServerConnectionNotice.css';

export const ServerConnectionNotice = observer(() => {
    if (!serverAvailabilityStore.shouldShowOfflineNotice) {
        return null;
    }

    return (
        <div className="ServerConnectionNotice body-medium" role="status" aria-live="polite">
            <span className="ServerConnectionNotice__title title-medium">
                {intl.get('server_connection.offline.title').d('Server connection unavailable')}
            </span>
            <span className="ServerConnectionNotice__message">
                {intl.get('server_connection.offline.message').d('Reconnecting. Cached data remains visible, but new changes may not sync yet.')}
            </span>
        </div>
    );
});
